/* eslint-disable no-undef */

export default {
	name: "confirm-delete-modal",
	props: ["elementId", "message", "showModal", "loading", "modalTitle"],
	emits: ["deleteConfirmed"],
	data() {
		return {
			titleForModal: "Delete?",
		};
	},
	methods: {
		onYesClick(){
			this.$emit("deleteConfirmed", true);
		},
		onNoClick(){
			this.$emit("deleteConfirmed", false);
		}
	},
	mounted: function () {
        
	},
	watch: {
		showModal: {
			handler: function () {
				if (this.showModal) {
					$("#" + this.elementId).modal("show");
				}
				else{
					$("#" + this.elementId).modal("hide");
				}
			}
		},
		modalTitle:{
			handler: function () {
				if(this.modalTitle){
					this.titleForModal = this.modalTitle;
				}
			},
			immediate: true,
			deep: true
		},
	}
};
